import type { Component } from "solid-js";
import { Show } from "solid-js";
import { useParams } from "@solidjs/router";
import CustomerId from "../state/CustomerId";
import UserService from "../services/UserService";
import ResourceNotFoundPage from "../pages/ResourceNotFoundPage";
import { keyFromSelector } from "i18next";
import { isNil } from "lodash-es";

type PermissionChecker = (customerId: CustomerId) => boolean;

const withPagePermissionCheck =
  <P extends object>(WrappedComponent: Component<P>, check: PermissionChecker): Component<P> =>
  (props) => {
    const params = useParams<{ customerId: string }>();
    const customerId = () => CustomerId.from(params.customerId);
    const permissionsQuery = UserService.getPermissions();

    const hasPermission = () => {
      if (isNil(permissionsQuery.data)) {
        return false;
      }
      return check(customerId());
    };

    return (
      <Show
        when={hasPermission()}
        fallback={
          <ResourceNotFoundPage
            illustration={{ primaryIcon: "lockClosed" }}
            resource={keyFromSelector(($) => $.RESOURCE_PAGE)}
          />
        }
      >
        <WrappedComponent {...props} />
      </Show>
    );
  };

export default withPagePermissionCheck;
